import React, {Component} from 'react';
import Structure from '../../inc/structure';
import FeatherIcon from 'feather-icons-react';
import GetApi from '../../api_request/Get';
import { ServerLink } from '../../keys/Links';
import notifyError from '../../inc/SnackbarError';
import NumberFormat from 'react-number-format';




class SmartPurseSavings extends Component{

    constructor(props) {
        super(props);
        this.state = {
            smartPurse: null,
            history: [],
            transferHistory: [],
            withdrawalHistory: [],
            isLoading: true,
            activeTab: 'transactions',
            countdownTrigger: 0,
        };
    }

    componentDidMount() {
        this.loadSmartPurseData();
        // Set up countdown timer to update every second
        this.countdownInterval = setInterval(() => {
            this.setState(prevState => ({
                countdownTrigger: prevState.countdownTrigger + 1
            }))
        }, 1000)
    }

    componentWillUnmount() {
        // Clean up interval on unmount
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval)
        }
    }

    loadSmartPurseData = () => {
        this.setState({ isLoading: true });
        
        GetApi(`${ServerLink}/user/smart-purse`).then(res => {
            if (res.status) {
                this.setState({
                    smartPurse: res.data,
                    history: res.history || [],
                    transferHistory: res.transfer_history || [],
                    withdrawalHistory: res.withdrawal_history || [],
                    isLoading: false
                });
            } else {
                notifyError(res.message || 'Failed to load Smart Purse data', 'error', 'top-center');
                this.setState({ isLoading: false });
            }
        }).catch(e => {
            console.error(e);
            notifyError('Error loading Smart Purse. Please try again.', 'error', 'top-center');
            this.setState({ isLoading: false });
        });
    }

    getTransactionStatus = (status) => {
        switch(status) {
            case 0:
                return { label: 'Pending', color: 'yellow', bgColor: 'bg-yellow-100', textColor: 'text-yellow-700' };
            case 1:
                return { label: 'Completed', color: 'green', bgColor: 'bg-green-100', textColor: 'text-green-700' };
            case 2:
                return { label: 'Failed', color: 'red', bgColor: 'bg-red-100', textColor: 'text-red-700' };
            default:
                return { label: 'Unknown', color: 'gray', bgColor: 'bg-gray-100', textColor: 'text-gray-700' };
        }
    }

    getPaymentMethodIcon = (method) => {
        switch(method) {
            case 'bank_transfer':
                return 'move';
            case 'virtual_account':
                return 'credit-card';
            default:
                return 'arrow-down';
        }
    }

    setActiveTab = (tab) => {
        this.setState({ activeTab: tab });
    }

    /**
     * Calculate time remaining until end date
     * Returns formatted string like "5d 2h 30m" or "Expired"
     */
    getTimeRemaining = (endDate) => {
        if (!endDate) return 'No deadline';
        
        const now = new Date();
        const end = new Date(endDate);
        const diff = end - now;
        
        if (diff <= 0) {
            return 'Expired';
        }
        
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / 1000 / 60) % 60);
        
        if (days > 0) {
            return `${days}d ${hours}h ${minutes}m`;
        } else if (hours > 0) {
            return `${hours}h ${minutes}m`;
        } else {
            return `${minutes}m`;
        }
    }

    render(){
        const { smartPurse, history, transferHistory, withdrawalHistory, isLoading, activeTab } = this.state;

        if (isLoading) {
            return (
                <Structure>
                    <div className="flex items-center justify-center py-20">
                        <div className="text-center">
                            <div className="inline-block w-12 h-12 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin mb-4"></div>
                            <p className="text-gray-600 workSanMedium">Loading Smart Purse data...</p>
                        </div>
                    </div>
                </Structure>
            );
        }

        if (!smartPurse) {
            return (
                <Structure>
                    <div className="bg-white rounded-xl shadow-lg p-8 text-center">
                        <FeatherIcon icon="alert-circle" size={48} className="mx-auto text-red-500 mb-4" />
                        <p className="text-gray-600 workSanMedium">Unable to load Smart Purse data</p>
                    </div>
                </Structure>
            );
        }

        const progressPercentage = ((smartPurse.smart_balance / smartPurse.target) * 100).toFixed(1);

        return(
            <Structure>
                <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                    
                    {/* Modern Header */}
                    <div className="bg-gradient-to-r from-blue-600 via-blue-500 to-indigo-600 text-white px-8 py-12">
                        <div className="flex items-start justify-between">
                            <div className="flex items-center flex-1">
                                <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg flex items-center justify-center mr-4">
                                    <FeatherIcon icon="zap" className="text-blue-500" size={32} />
                                </div>
                                <div>
                                    <div className="flex items-center gap-2 mb-1">
                                        <h1 className="workSanBold text-3xl">Smart Purse Savings</h1>
                                        {smartPurse && smartPurse.is_locked && (
                                            <div className="w-6 h-6 bg-red-400 rounded flex items-center justify-center" title="Locked">
                                                <FeatherIcon icon="lock" size={16} className="text-white" />
                                            </div>
                                        )}
                                    </div>
                                    <p className="text-blue-100 text-sm workSanMedium">Your default purse for automated savings</p>
                                    {smartPurse && smartPurse.end_date && (
                                        <p className="text-blue-100 text-xs workSanMedium mt-2 flex items-center gap-1">
                                            <FeatherIcon icon="clock" size={12} />
                                            Ends in: {this.getTimeRemaining(smartPurse.end_date)}
                                        </p>
                                    )}
                                </div>
                            </div>
                            <button 
                                onClick={this.loadSmartPurseData}
                                className="bg-white text-blue-600 px-6 py-3 rounded-lg workSanBold hover:shadow-lg transition flex items-center gap-2"
                            >
                                <FeatherIcon icon="refresh-cw" size={18} />
                                Refresh
                            </button>
                        </div>
                    </div>

                    <div className="p-8">
                        {/* Overview Cards */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
                            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-6 border border-blue-100">
                                <p className="text-gray-600 text-sm workSanMedium mb-2">Current Balance</p>
                                <h2 className="workSanBold text-3xl text-gray-900 mb-4">
                                    <span className="text-lg">₦</span>
                                    <NumberFormat value={smartPurse.smart_balance} displayType="text" thousandSeparator={true} />
                                </h2>
                                <div className="flex items-center gap-2">
                                    <div className="flex-1 bg-gray-200 rounded-full h-2">
                                        <div 
                                            style={{ width: `${Math.min(progressPercentage, 100)}%` }}
                                            className="h-2 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full"
                                        ></div>
                                    </div>
                                    <span className="text-xs workSanBold text-gray-900">{progressPercentage}%</span>
                                </div>
                            </div>

                            <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-6 border border-green-100">
                                <p className="text-gray-600 text-sm workSanMedium mb-2">Target Amount</p>
                                <h2 className="workSanBold text-3xl text-gray-900">
                                    <span className="text-lg">₦</span>
                                    <NumberFormat value={smartPurse.target} displayType="text" thousandSeparator={true} />
                                </h2>
                                <p className="text-xs text-gray-600 mt-4 workSanMedium">
                                    <span className="text-green-600 workSanBold">₦<NumberFormat value={smartPurse.target - smartPurse.smart_balance} displayType="text" thousandSeparator={true} /></span> remaining
                                </p>
                            </div>

                            <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl p-6 border border-purple-100">
                                <p className="text-gray-600 text-sm workSanMedium mb-2">Account Status</p>
                                <div className="mb-4">
                                    <span className={`inline-block px-4 py-2 rounded-full text-sm workSanBold ${
                                        smartPurse.status === 0 ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'
                                    }`}>
                                        {smartPurse.status === 0 ? 'Active' : 'Inactive'}
                                    </span>
                                </div>
                                <p className="text-xs text-gray-600 workSanMedium">
                                    Last updated: {smartPurse.last_update}
                                </p>
                            </div>
                        </div>

                        {/* Tab Navigation */}
                        <div className="mb-8 border-b border-gray-200">
                            <div className="flex gap-8">
                                <button
                                    onClick={() => this.setActiveTab('transactions')}
                                    className={`pb-4 px-2 font-medium transition-all duration-300 border-b-2 workSanMedium flex items-center gap-2 ${
                                        activeTab === 'transactions'
                                            ? 'border-blue-600 text-blue-600'
                                            : 'border-transparent text-gray-600 hover:text-gray-900'
                                    }`}
                                >
                                    <FeatherIcon icon="arrow-down-left" size={18} />
                                    Transactions ({history.length})
                                </button>
                                
                                <button
                                    onClick={() => this.setActiveTab('transfers')}
                                    className={`pb-4 px-2 font-medium transition-all duration-300 border-b-2 workSanMedium flex items-center gap-2 ${
                                        activeTab === 'transfers'
                                            ? 'border-blue-600 text-blue-600'
                                            : 'border-transparent text-gray-600 hover:text-gray-900'
                                    }`}
                                >
                                    <FeatherIcon icon="send" size={18} />
                                    Transfers ({transferHistory.length})
                                </button>
                                
                                <button
                                    onClick={() => this.setActiveTab('withdrawals')}
                                    className={`pb-4 px-2 font-medium transition-all duration-300 border-b-2 workSanMedium flex items-center gap-2 ${
                                        activeTab === 'withdrawals'
                                            ? 'border-blue-600 text-blue-600'
                                            : 'border-transparent text-gray-600 hover:text-gray-900'
                                    }`}
                                >
                                    <FeatherIcon icon="arrow-up-right" size={18} />
                                    Withdrawals ({withdrawalHistory.length})
                                </button>
                            </div>
                        </div>

                        {/* Transactions Tab */}
                        {activeTab === 'transactions' && (
                            <div>
                                {history.length > 0 ? (
                                    <div className="space-y-3">
                                        {history.map((transaction, index) => {
                                            const status = this.getTransactionStatus(transaction.status);
                                            const method = transaction.payment_method;
                                            return (
                                                <div key={index} className="bg-white border border-gray-100 rounded-lg p-4 hover:shadow-md transition flex items-center justify-between">
                                                    <div className="flex items-center gap-4 flex-1">
                                                        <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                                                            <FeatherIcon icon={this.getPaymentMethodIcon(method)} className="text-blue-600" size={20} />
                                                        </div>
                                                        <div className="flex-1">
                                                            <h4 className="workSanBold text-gray-900">{transaction.title}</h4>
                                                            <p className="text-xs text-gray-600 workSanMedium">{transaction.payment_method === 'bank_transfer' ? 'Bank Transfer' : 'Virtual Account'} • {transaction.date}</p>
                                                            <p className="text-xs text-gray-500 mt-1">ID: {transaction.trans_id}</p>
                                                        </div>
                                                    </div>
                                                    <div className="text-right">
                                                        <p className="workSanBold text-lg text-gray-900">₦<NumberFormat value={transaction.amount} displayType="text" thousandSeparator={true} /></p>
                                                        <span className={`inline-block mt-2 px-3 py-1 rounded-full text-xs workSanBold ${status.bgColor} ${status.textColor}`}>
                                                            {status.label}
                                                        </span>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <div className="text-center py-12 bg-gray-50 rounded-xl border-2 border-dashed border-gray-300">
                                        <FeatherIcon icon="inbox" className="mx-auto text-gray-400 mb-3" size={48} />
                                        <p className="text-gray-600 workSanMedium">No transactions yet</p>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Transfers Tab */}
                        {activeTab === 'transfers' && (
                            <div>
                                {transferHistory.length > 0 ? (
                                    <div className="space-y-3">
                                        {transferHistory.map((transfer, index) => {
                                            const isOutgoing = transfer.from_type === 'smart_purse';
                                            return (
                                                <div key={index} className="bg-white border border-gray-100 rounded-lg p-4 hover:shadow-md transition">
                                                    <div className="flex items-center justify-between mb-3">
                                                        <div className="flex items-center gap-3">
                                                            <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${isOutgoing ? 'bg-orange-100' : 'bg-green-100'}`}>
                                                                <FeatherIcon icon={isOutgoing ? 'arrow-up-right' : 'arrow-down-left'} className={isOutgoing ? 'text-orange-600' : 'text-green-600'} size={20} />
                                                            </div>
                                                            <div>
                                                                <h4 className="workSanBold text-gray-900">
                                                                    {isOutgoing ? 'Transfer to' : 'Transfer from'} {isOutgoing ? transfer.to_name : transfer.from_name}
                                                                </h4>
                                                                <p className="text-xs text-gray-600 workSanMedium">ID: {transfer.transfer_uid}</p>
                                                            </div>
                                                        </div>
                                                        <div className="text-right">
                                                            <p className={`workSanBold text-lg ${isOutgoing ? 'text-red-600' : 'text-green-600'}`}>
                                                                {isOutgoing ? '-' : '+'}₦<NumberFormat value={transfer.amount} displayType="text" thousandSeparator={true} />
                                                            </p>
                                                            <span className="inline-block mt-2 px-3 py-1 rounded-full text-xs workSanBold bg-green-100 text-green-700">
                                                                Completed
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {transfer.penalty_charges > 0 && (
                                                        <div className="text-xs text-red-600 bg-red-50 rounded p-2">
                                                            Penalty: ₦{transfer.penalty_charges} - {transfer.penalty_note}
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <div className="text-center py-12 bg-gray-50 rounded-xl border-2 border-dashed border-gray-300">
                                        <FeatherIcon icon="inbox" className="mx-auto text-gray-400 mb-3" size={48} />
                                        <p className="text-gray-600 workSanMedium">No transfers yet</p>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Withdrawals Tab */}
                        {activeTab === 'withdrawals' && (
                            <div>
                                {withdrawalHistory.length > 0 ? (
                                    <div className="space-y-3">
                                        {withdrawalHistory.map((withdrawal, index) => {
                                            const status = this.getTransactionStatus(withdrawal.status);
                                            return (
                                                <div key={index} className="bg-white border border-gray-100 rounded-lg p-4 hover:shadow-md transition flex items-center justify-between">
                                                    <div className="flex items-center gap-4 flex-1">
                                                        <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
                                                            <FeatherIcon icon="arrow-up" className="text-purple-600" size={20} />
                                                        </div>
                                                        <div className="flex-1">
                                                            <h4 className="workSanBold text-gray-900">Withdrawal to {withdrawal.bank}</h4>
                                                            <p className="text-xs text-gray-600 workSanMedium">{withdrawal.account_number} • {withdrawal.date}</p>
                                                            <p className="text-xs text-gray-500 mt-1">Ref: {withdrawal.reference}</p>
                                                        </div>
                                                    </div>
                                                    <div className="text-right">
                                                        <p className="workSanBold text-lg text-gray-900">₦<NumberFormat value={withdrawal.amount} displayType="text" thousandSeparator={true} /></p>
                                                        <span className={`inline-block mt-2 px-3 py-1 rounded-full text-xs workSanBold ${status.bgColor} ${status.textColor}`}>
                                                            {status.label}
                                                        </span>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <div className="text-center py-12 bg-gray-50 rounded-xl border-2 border-dashed border-gray-300">
                                        <FeatherIcon icon="inbox" className="mx-auto text-gray-400 mb-3" size={48} />
                                        <p className="text-gray-600 workSanMedium">No withdrawals yet</p>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>

            </Structure>
        );
    }
}


export default SmartPurseSavings;